import { AuthError } from "pages/Auth/AuthError";
import { AuthSuccess } from "pages/Auth/AuthSuccess";
import Login from "pages/Auth/Login";
import Register from "pages/Auth/Register";
import UserAccountPage from "pages/Auth/UserAccount";
import { FeedbackPage } from "pages/Feedback";
import { NotFound } from "pages/NotFound";
import { PrivacyPolicy } from "pages/Ops/Privacy";
import { TermsOfService } from "pages/Ops/ToS";
import { SocialMetrics } from "pages/SocialMetrics";
import { AuthProvider, useAuth } from "providers/auth.provider";
import { SiteProvider } from "providers/site.provider";
import { ReactNode } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import ClientForm from "./pages/ClientForm";
import Dashboard from "./pages/Dashboard";
import Reports from "./pages/Reports";
import WebsiteSelection from "./pages/WebsiteSelection";
import { GoogleMetrics } from "pages/Google/GoogleMetrics";
import { Maintenance } from "pages/Maintenance";

interface PrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>; // Or replace with a spinner component
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <AuthProvider>
        <SiteProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/websites" replace />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/success" element={<AuthSuccess />} />
            <Route path="/auth/error" element={<AuthError />} />
            <Route path="/tos" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />

            <Route
              path="/websites"
              element={
                <PrivateRoute>
                  <WebsiteSelection />
                </PrivateRoute>
              }
            />
            <Route
              path="/websites/new"
              element={
                <PrivateRoute>
                  <ClientForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <PrivateRoute>
                  <Reports />
                </PrivateRoute>
              }
            />
            <Route
              path="/social"
              element={
                <PrivateRoute>
                  <SocialMetrics />
                </PrivateRoute>
              }
            />
            <Route
              path="/feedback"
              element={
                <PrivateRoute>
                  <FeedbackPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/account"
              element={
                <PrivateRoute>
                  <UserAccountPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/seo"
              element={
                <PrivateRoute>
                  <GoogleMetrics />
                </PrivateRoute>
              }
            />

            <Route
              path="/maintenance"
              element={
                <PrivateRoute>
                  <Maintenance />
                </PrivateRoute>
              }
            />

            {/* Catch-all */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </SiteProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
